import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { useAuth } from '../../Auth';
import { useSelector } from 'react-redux';
import logo from '../../../assets/FullLogo.svg';
import ShortLogo from '../../../assets/AssetFallBackLight.svg';
import FolderOpenIcon from '../../../assets/FolderOpenIcon.svg';
import profileDashboardIcon from '../../../assets/ProfileDashboard.svg';
import inboxIcon from '../../../assets/Inbox.svg';
import noteIcon from '../../../assets/Note.svg';
import profileIcon from '../../../assets/Profile.svg';
import SquareUpArrow from '../../../assets/SquareUpArrow.svg';
import GearIcon from '../../../assets/GearIcon.svg';
import LogOutIcon from '../../../assets/LogOutIcon.svg';
import RefreshIcon from '../../../assets/RefreshIcon.svg';
import OrderTab from './components/OrderTab';
import SettingsIcon from '../../../assets/SettingsIcon.svg';
import SiteMap from '../../../assets/SiteMap.svg';
import Calculator from '../../../assets/Calculator.svg';
import LeftArrow from '../../../assets/ArrowRightLineWhite.svg';
import FourSquareIcon from '../../../assets/FourSquareIcon.svg';

import { Popover } from 'react-tiny-popover';
// import { Popover as AntdPopover } from 'antd';
import UserAccount from '../../../pages/UserAccount';
import DashBoardTab from './components/DashBoardTab';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../../constants/ROUTES';
import ProfileTab from './components/ProfileTab';
import { GROUPS, USERSTYPES } from '../../../constants/ROLES';
import ControlCenter from './components/ControlCenter';
import ProjectsTab from './components/ProjectsTab';
import CommunicationsTab from './components/CommunicationsTab';
import ResetDemoModal from '../../ResetDemoModal';
import scrollBarStyle from '../../../scrollbar.module.css';

// Constants
const DESKTOP_BREAKPOINT = 640;

// Stable data-tour id derived from a nav item's name, e.g. "Site Map" ->
// "nav-site-map". Lets the product tour target items without hardcoding
// role-specific lists here.
const navTourId = (name) =>
  `nav-${String(name || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')}`;

const SideNavBar = () => {
  const ADMIN_MANAGER_ROLES = [USERSTYPES.ADMIN, USERSTYPES.MANAGER];
  const navigation = useNavigate();
  const { handleLogout } = useAuth();
  const { userDetails } = useSelector((state) => state?.userDetails);
  const [isSideBarOpen, setIsSideBarOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [userDetailsModalOpen, setUserDetailsModalOpen] = useState(false);
  const [openTabName, setOpenTabName] = useState(null);
  const [isProfilePopOverOpen, setIsProfilePopOverOpen] = useState(false);
  const [resetDemoModalOpen, setResetDemoModalOpen] = useState(false);

  const isAdminGroup = GROUPS.ADMINACCESSGROUP.includes(
    userDetails?.user?.role?.label
  );

  // Demo data reset is restricted to the Admin role only
  const isAdmin = USERSTYPES.ADMIN === userDetails?.user?.role?.label;

  const isClientGroup = GROUPS.CLIENTACCESSGROUP.includes(
    userDetails?.user?.role?.label
  );

  const sideTabList = [
    // {
    //   icon: dashboardIcon,
    //   elementName: 'dashboard',
    //   name: 'Quick Access',
    //   type: 'tab'
    // },

    ...(isClientGroup
      ? [
          {
            icon: FourSquareIcon,
            elementName: ROUTES.dashbaord,
            name: 'Dashboard',
            type: 'navigation'
          }
        ]
      : []),

    ...(isAdminGroup
      ? [
          {
            icon: inboxIcon,
            elementName: 'communications',
            name: 'Communications',
            type: 'tab'
          }
        ]
      : []),
    {
      icon: noteIcon,
      elementName: 'orders',
      name: 'Orders',
      type: 'tab'
    },

    ...(isAdminGroup
      ? [
          {
            icon: FolderOpenIcon,
            elementName: 'projects',
            name: 'Projects',
            type: 'tab'
          }
        ]
      : []),

    {
      icon: SiteMap,
      elementName: ROUTES.siteMap,
      name: 'Site Map',
      type: 'navigation'
    },

    {
      icon: Calculator,
      elementName: ROUTES.rateCalculator,
      name: 'Rate Calculator',
      type: 'navigation',
      iconStyle: 'ml-1'
    },

    // Admin Group - Show profile tab for Admin Group
    ...(isAdminGroup
      ? [
          {
            icon: profileDashboardIcon,
            elementName: 'profile',
            name: 'Partner Profiles',
            type: 'tab'
          }
        ]
      : []),

    // Client Admin
    ...(USERSTYPES?.Client_Admin === userDetails?.user?.role?.label
      ? [
          {
            icon: profileDashboardIcon,
            elementName: `${ROUTES.profile}/${userDetails?.user?.partnerProfileId}`,
            name: 'Contacts',
            type: 'navigation'
          }
        ]
      : []),

    // Only Show Control Center Tab to Admin and Manager Roles (Internal Users)
    ...(isAdminGroup &&
    ADMIN_MANAGER_ROLES?.includes(userDetails?.user?.role?.label)
      ? [
          {
            icon: SettingsIcon,
            elementName: 'controlCenter',
            name: 'Control Center',
            type: 'tab',
            iconStyle: 'mt-0.5'
          }
        ]
      : [])
  ];

  const toggleIsSideBarOpen = () => {
    setIsSideBarOpen((pre) => !pre);
  };

  const toggleMinimized = () => {
    setIsMinimized((pre) => !pre);
    // Close any open tabs when minimizing
    if (!isMinimized) {
      setOpenTabName(null);
    }
  };

  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth
  });

  function debounce(fn, ms) {
    let timer;
    return () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        fn();
      }, ms);
    };
  }

  const handleChangeTab = (name, type) => {
    setIsSideBarOpen(false);

    if (type === 'navigation') {
      setOpenTabName(null);
      navigation(name);
    } else {
      setOpenTabName(name);
    }
  };

  const toggleProfilePopOver = () => {
    setIsProfilePopOverOpen((pre) => !pre);
  };

  const toggleUserDetailsModal = () => {
    setUserDetailsModalOpen((pre) => !pre);
  };

  const toggleResetDemoModal = () => {
    setResetDemoModalOpen((pre) => !pre);
  };

  const handleClickLogout = async () => {
    toggleIsSideBarOpen();
    handleLogout();
  };

  useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      });
    }, 50);

    window.addEventListener('resize', debouncedHandleResize);

    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, [dimensions]);

  return (
    <>
      {dimensions.width < DESKTOP_BREAKPOINT && !isSideBarOpen ? (
        <div className='z-[5] flex absolute w-14 h-12 bg-gray-200  rounded justify-center items-center opacity-80'>
          <button onClick={toggleIsSideBarOpen}>
            <img src={SquareUpArrow} className='rotate-90' alt='Arrow' />
          </button>
        </div>
      ) : (
        <div
          data-tour='nav-sidebar'
          className={`absolute sm:relative bg-secondary-500 ${
            dimensions.width >= DESKTOP_BREAKPOINT && isMinimized
              ? 'w-[70px]'
              : 'w-[60%] sm:w-[222px] sm:min-w-fit'
          } flex flex-col h-full ${
            openTabName === null ? 'z-[15]' : 'z-[16]'
          } transition-all duration-300 ease-in-out`}
        >
          {/* Close In Case of Small device */}
          <div className='z-[5] absolute sm:hidden right-[-2px] top-[15px] rounded p-1 py-0 shadow-md'>
            <button onClick={toggleIsSideBarOpen}>
              <img src={SquareUpArrow} className='-rotate-90' alt='Arrow' />
            </button>
          </div>

          <div
            onClick={() => {
              setOpenTabName(null);
              navigation(ROUTES.dashbaord);
            }}
            className={`flex ${
              isMinimized && dimensions.width >= DESKTOP_BREAKPOINT
                ? 'justify-center'
                : 'justify-center'
            } mt-6 cursor-pointer ${
              isMinimized && dimensions.width >= DESKTOP_BREAKPOINT
                ? 'px-2'
                : ''
            } relative`}
          >
            {isMinimized && dimensions.width >= DESKTOP_BREAKPOINT ? (
              <img src={ShortLogo} className='w-7 h-7' alt='Logo' />
            ) : (
              <img src={logo} alt='Logo' />
            )}

            {/* Minimize/Expand Button for screens >= 640px */}
            {dimensions.width >= DESKTOP_BREAKPOINT && openTabName === null && (
              <button
                data-tour='nav-minimize'
                onClick={(e) => {
                  e.stopPropagation(); // Prevent navigation when clicking the button
                  toggleMinimized();
                }}
                className='absolute -right-2 top-1/2 transform -translate-y-1/2 bg-secondary-400 hover:opacity-90 shadow shadow-black/50 p-1 rounded-full'
                title={isMinimized ? 'Expand sidebar' : 'Minimize sidebar'}
              >
                <img
                  src={LeftArrow}
                  className={`w-3 h-3 transition-transform ${
                    isMinimized ? '' : 'rotate-180'
                  }`}
                  alt='Left arrow'
                />
              </button>
            )}
          </div>

          <div
            className={`mt-6 flex-1 overflow-y-auto pb-2 ${scrollBarStyle.customScroll}`}
          >
            <SideNavBarTab
              sideTabList={sideTabList}
              openTabName={openTabName}
              handleChangeTab={handleChangeTab}
              isMinimized={isMinimized}
              dimensions={dimensions}
            />
          </div>

          {/* User Profile Icon and Popover */}

          <Popover
            isOpen={isProfilePopOverOpen}
            align={'start'}
            onClickOutside={() => {
              toggleProfilePopOver();
            }}
            reposition={false}
            positions={['top']}
            content={
              <div className='flex flex-col w-[200px] bg-white divide-y divide-neutral-200 rounded-lg overflow-hidden shadow border border-neutral-100'>
                <button
                  onClick={() => {
                    setIsSideBarOpen(false);
                    toggleProfilePopOver();
                    toggleUserDetailsModal();
                  }}
                  className='flex flex-row p-2 hover:bg-neutral-200 gap-x-3 items-center'
                >
                  <img src={GearIcon} className='w-6 h-6' alt='Settings' />
                  <span className='text-sm mb-0.5'>Account</span>
                </button>

                {isAdmin && (
                  <button
                    onClick={() => {
                      setIsSideBarOpen(false);
                      toggleProfilePopOver();
                      toggleResetDemoModal();
                    }}
                    className='flex flex-row p-2 hover:bg-neutral-200 gap-x-3 items-center'
                  >
                    <img
                      src={RefreshIcon}
                      className='w-6 h-6'
                      alt='Reset demo'
                    />
                    <span className='text-sm mb-0.5'>Reset Demo</span>
                  </button>
                )}

                <button
                  onClick={handleClickLogout}
                  className='flex flex-row p-2 hover:bg-neutral-200 gap-x-3 items-center'
                >
                  <img src={LogOutIcon} className='w-6 h-6' alt='Logo' />
                  <span className='text-sm mb-0.5'>Sign out</span>
                </button>
              </div>
            }
            containerStyle={{
              zIndex: 16,
              paddingBottom: '11px'
            }}
          >
            <button
              data-tour='nav-profile'
              onClick={toggleProfilePopOver}
              className={`flex flex-row mt-1 mb-6 mx-3 items-center ${
                isMinimized && dimensions.width >= DESKTOP_BREAKPOINT
                  ? 'justify-center'
                  : ''
              }`}
              title={
                isMinimized && dimensions.width >= DESKTOP_BREAKPOINT
                  ? `${userDetails?.user?.first_name} ${userDetails?.user?.last_name}`
                  : ''
              }
            >
              <img src={profileIcon} alt='File' />
              {(!isMinimized || dimensions.width < DESKTOP_BREAKPOINT) && (
                <span className='px-2 text-white text-base'>
                  {userDetails?.user?.first_name +
                    ' ' +
                    userDetails?.user?.last_name}
                </span>
              )}
            </button>
          </Popover>
        </div>
      )}

      {/* User Account Modal */}
      {userDetailsModalOpen && (
        <UserAccount
          isOpen={userDetailsModalOpen}
          toggleModal={toggleUserDetailsModal}
        />
      )}

      {/* Reset Demo Modal - Admin only */}
      {isAdmin && resetDemoModalOpen && (
        <ResetDemoModal
          isOpen={resetDemoModalOpen}
          toggleModal={toggleResetDemoModal}
        />
      )}

      {openTabName !== null && (
        <SideBarContentModal
          isOpen={openTabName !== null}
          onClose={() => {
            setOpenTabName(null);
          }}
          openTabName={openTabName}
          isMinimized={isMinimized}
          dimensions={dimensions}
        />
      )}
    </>
  );
};

const SideBarContentModal = ({
  isOpen,
  onClose,
  openTabName,
  isMinimized,
  dimensions
}) => {
  const getModalLeftPosition = () => {
    if (dimensions.width >= DESKTOP_BREAKPOINT) {
      return isMinimized ? 'sm:left-[76px]' : 'sm:left-[228px]';
    }
    return 'sm:left-[228px]';
  };

  const renderModalContent = () => {
    switch (openTabName) {
      case 'dashboard':
        return <DashBoardTab closeModal={onClose} />;
      case 'orders':
        return <OrderTab closeModal={onClose} />;
      case 'profile':
        return <ProfileTab closeModal={onClose} />;

      case 'controlCenter':
        return <ControlCenter closeModal={onClose} />;

      case 'projects':
        return <ProjectsTab closeModal={onClose} />;

      case 'communications':
        return <CommunicationsTab closeModal={onClose} />;

      default:
        <></>;
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      // -translate-y-1/2 top-1/2
      className={`flex flex-col max-w-[95%] sm:max-w-[320px] transform -translate-x-1/2 sm:translate-x-0 left-1/2 ${getModalLeftPosition()} max-h-full relative`}
      overlayClassName={'fixed top-0 left-0 right-0 bottom-0 bg-black/60 py-2'}
      style={{ overlay: { zIndex: 15 } }}
      ariaHideApp={false}
      shouldCloseOnOverlayClick={true}
    >
      <div className='rounded-lg w-full bg-secondary-500 overflow-hidden p-2.5'>
        <div className='flex flex-row justify-end text-xs text-primary-100 mb-1 visible sm:hidden '>
          <button onClick={onClose}>Close</button>
        </div>
        {renderModalContent()}
      </div>
    </Modal>
  );
};

const SideNavBarTab = ({
  sideTabList,
  openTabName,
  handleChangeTab,
  isMinimized,
  dimensions
}) => {
  return (
    <div className='flex flex-col gap-y-2 px-2'>
      {sideTabList.map((sideBardItem, index) => (
        <button
          key={index}
          data-tour={navTourId(sideBardItem?.name)}
          onClick={() => {
            handleChangeTab(sideBardItem?.elementName, sideBardItem?.type);
          }}
          className={`flex flex-row items-center gap-x-2 w-full rounded-md p-1.5 ${
            openTabName === sideBardItem?.elementName
              ? 'bg-gray-100 text-black/80'
              : 'hover:bg-secondary-400 text-white'
          } ${
            isMinimized && dimensions.width >= DESKTOP_BREAKPOINT
              ? 'justify-center'
              : ''
          }`}
          title={
            isMinimized && dimensions.width >= DESKTOP_BREAKPOINT
              ? sideBardItem?.name
              : ''
          }
        >
          <div className='w-6 h-6 flex-shrink-0'>
            <img
              src={sideBardItem?.icon}
              className={`${sideBardItem?.iconStyle ?? ''}`}
              alt='Side Bard Item?'
            />
          </div>

          {(!isMinimized || dimensions.width < DESKTOP_BREAKPOINT) && (
            <span className='text-sm'>{sideBardItem?.name}</span>
          )}
        </button>
      ))}
    </div>
  );
};

export default SideNavBar;
